export const RESET = 'RETINA_DEMO/RESET';
export const FETCH_PRODUCTS_DATA = 'RETINA_DEMO/FETCH_PRODUCTS_DATA';
export const FETCH_PRODUCTS_LOADING = 'RETINA_DEMO/FETCH_PRODUCTS_LOADING';
export const FETCH_PRODUCTS_ERROR = 'RETINA_DEMO/FETCH_PRODUCTS_ERROR';
export const SET_PRODUCT_ID = 'RETINA_DEMO/SET_PRODUCT_ID';
export const SET_POLLUTANT = 'RETINA_DEMO/SET_POLLUTANT';
export const SET_MEMBER = 'RETINA_DEMO/SET_MEMBER';
export const SET_MONTH = 'RETINA_DEMO/SET_MONTH';
export const SET_DAY = 'RETINA_DEMO/SET_DAY';
export const SET_HOUR = 'RETINA_DEMO/SET_HOUR';
export const SET_YEAR = 'RETINA_DEMO/SET_YEAR';
export const SET_DATE = 'RETINA_DEMO/SET_DATE';
export const SET_COMPARING_DATE = 'RETINA_DEMO/SET_COMPARING_DATE';
export const UPDATE_DATE = 'RETINA_DEMO/UPDATE_DATE';
export const UPDATE_COMPARING_DATE = 'RETINA_DEMO/UPDATE_COMPARING_DATE';
export const UPDATE_DAY = 'RETINA_DEMO/UPDATE_DAY';
export const UPDATE_MONTH = 'RETINA_DEMO/UPDATE_MONTH';
export const UPDATE_HOUR = 'RETINA_DEMO/UPDATE_HOUR';
export const UPDATE_DATE_TIMEZONE = 'RETINA_DEMO/UPDATE_DATE_TIMEZONE';
export const UPDATE_COMPARING_DATE_TIMEZONE = 'RETINA_DEMO/UPDATE_COMPARING_DATE_TIMEZONE';
export const SET_LOCAL_DATE = 'RETINA_DEMO/SET_LOCAL_DATE';
export const SET_COMPARING_YEAR = 'RETINA_DEMO/SET_COMPARING_YEAR';
export const SET_COMPARING_MONTH = 'RETINA_DEMO/SET_COMPARING_MONTH';
export const SET_COMPARING_DAY = 'RETINA_DEMO/SET_COMPARING_DAY';
export const SET_COMPARING_HOUR = 'RETINA_DEMO/SET_COMPARING_HOUR';
export const SET_STATE = 'RETINA_DEMO/SET_STATE';
export const SET_BASEMAP = 'RETINA_DEMO/SET_BASEMAP';
export const SET_LABELS = 'RETINA_DEMO/SET_LABELS';
export const SET_BOUNDARY = 'RETINA_DEMO/SET_BOUNDARY';
export const SET_LANGUAGE = 'RETINA_DEMO/SET_LANGUAGE';
export const SET_TIMEZONE = 'RETINA_DEMO/SET_TIMEZONE';
export const SET_ZONE = 'RETINA_DEMO/SET_ZONE';
export const SET_COMPARING_TIMEZONE = 'RETINA_DEMO/SET_COMPARING_TIMEZONE';
export const SET_COMPARING_ZONE = 'RETINA_DEMO/SET_COMPARING_ZONE';
export const SET_VIEWPORT = 'RETINA_DEMO/SET_VIEWPORT';

export const defaultState = {
  // Raw data from the API
  products: { loading: false, error: false, data: [] },
  // Actual state of the demo
  state: {
    productId: null,
    pollutant: null,
    member: null,
    year: null,
    month: null,
    day: null,
    hour: null,
    date: null,
    comparingDate: null,
    comparingYear: null,
    comparingMonth: null,
    comparingDay: null,
    comparingHour: null,
    basemap: 'satellite',
    labels: 'light',
    boundary: 'light',
    language: 'english',
    timezone: 0,
    dateTimezone: 'DD/MM/YYYY 00:00',
    viewport: null,
    zone: 'Coordinated Universal Time ',
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case RESET:
      return defaultState;

    case FETCH_PRODUCTS_DATA:
      return Object.assign({}, state, {
        products: Object.assign({}, state.products, { data: action.payload }),
      });

    case FETCH_PRODUCTS_LOADING:
      return Object.assign({}, state, {
        products: Object.assign({}, state.products, {
          loading: action.payload,
        }),
      });

    case FETCH_PRODUCTS_ERROR:
      return Object.assign({}, state, {
        products: Object.assign({}, state.products, { error: action.payload }),
      });

    case SET_PRODUCT_ID:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { productId: action.payload }),
      });

    case SET_POLLUTANT:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { pollutant: action.payload }),
      });

    case SET_MEMBER:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { member: action.payload }),
      });

    case SET_YEAR:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { year: action.payload }),
      });
    case SET_MONTH:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { month: action.payload }),
      });

    case SET_DAY:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { day: action.payload }),
      });

    case UPDATE_DAY:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { day: action.payload }),
      });

    case SET_HOUR:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { hour: action.payload }),
      });

    case SET_DATE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { date: action.payload }),
      });

    case SET_COMPARING_DATE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, {
          comparingDate: action.payload,
        }),
      });

    case SET_COMPARING_YEAR:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, {
          comparingYear: action.payload,
        }),
      });

    case SET_COMPARING_MONTH:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, {
          comparingMonth: action.payload,
        }),
      });

    case SET_COMPARING_DAY:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { comparingDay: action.payload }),
      });

    case SET_COMPARING_HOUR:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, {
          comparingHour: action.payload,
        }),
      });

    case SET_STATE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, action.payload),
      });

    case SET_BASEMAP:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { basemap: action.payload }),
      });

    case SET_LABELS:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { labels: action.payload }),
      });

    case SET_BOUNDARY:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { boundary: action.payload }),
      });

    case SET_LANGUAGE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { language: action.payload }),
      });

    case SET_TIMEZONE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { timezone: action.payload }),
      });

    case SET_ZONE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { zone: action.payload }),
      });

    case SET_VIEWPORT:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { viewport: action.payload }),
      });

    case UPDATE_DATE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { date: action.payload }),
      });

    case UPDATE_COMPARING_DATE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, {
          comparingDate: action.payload,
        }),
      });

    case UPDATE_DATE_TIMEZONE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, { dateTimezone: action.payload }),
      });

    case UPDATE_COMPARING_DATE_TIMEZONE:
      return Object.assign({}, state, {
        state: Object.assign({}, state.state, {
          comparingDateTimezone: action.payload,
        }),
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/retina-demo/reducer.js